import { render, staticRenderFns } from "./GeneralPageLanguage.vue?vue&type=template&id=2d735f27&scoped=true&lang=pug&"
import script from "./GeneralPageLanguage.vue?vue&type=script&lang=js&"
export * from "./GeneralPageLanguage.vue?vue&type=script&lang=js&"
import style0 from "./GeneralPageLanguage.vue?vue&type=style&index=0&id=2d735f27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d735f27",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VRadio,VRadioGroup,VSpacer})
